


<div class="body" [chart]="chart" [ngStyle]="{'width':width +'px','height':height+'px','display':'block'}"></div>
